<template>
    <div class="form-map-panel">
        <div class="section-title-panel">
            <h2 class="section-title">{{ lang.title }}</h2>
            <button type="button" class="btn-clear"
                    @click="clearFilterForm(); clearFormMsg();">{{ lang.clear }}
            </button>
        </div>

        <form class="row form-panel form-map" action="/"
              id="filterForm" v-model="stateManager.get" autocomplete="on">

            <div class="form-panel-inner scrollbar-styled--inner">
                <div class="row">
                    <div class="form-group col-md-6">
                        <label for="select_offer" class="col-lg-12 label-primary">{{ lang.offerType }}</label>
                        <select id="select_offer"
                                class="selectpicker form-control select-primary col-lg-12"
                                :title="lang.allOffers"
                                v-on:change="removeCurrentPage"
                                v-model="vueGetSelectedOption.offer">

                            <option value="default" selected>{{ lang.allOffers }}</option>


                            <template v-for="option of vueCreateSelectOptions.offer">
                                <option :value="option">
                                    <template v-for="langItem of langForm">
                                        <template v-if="option === langItem.key">
                                            {{ langItem.value }}
                                        </template>
                                    </template>
                                </option>
                            </template>
                        </select>
                    </div>

                    <div class="form-group col-md-6">
                        <label for="select_room_type" class="col-lg-12 label-primary">{{ lang.room_type }}</label>
                        <select id="select_room_type"
                                class="selectpicker form-control select-primary col-lg-12"
                                :title="lang.allRoomTypes"
                                v-on:change="removeCurrentPage"
                                v-model="vueGetSelectedOption.room">

                            <option value="default" selected>{{ lang.allRoomTypes }}</option>

                            <template v-for="option of vueCreateSelectOptions.room">
                                <option :value="option">
                                    <template v-for="langItem of langForm">
                                        <template v-if="option === langItem.key">
                                            {{ langItem.value }}
                                        </template>
                                    </template>
                                </option>
                            </template>
                        </select>
                    </div>
                </div>

                <div class="row">
                    <div class="form-group col-md-6">
                        <label for="select_city" class="col-lg-12 label-primary">{{ lang.chooseCity }}</label>
                        <div class="styled-select">
                            <select id="select_city"
                                    class="selectpicker form-control select-primary col-lg-12"
                                    :title="lang.allCities"
                                    v-on:change="removeCurrentPage"
                                    v-model="vueGetSelectedOption.city">

                                <option value="default" selected>{{ lang.allCities }}</option>

                                <template v-for="option of vueCreateSelectOptions.city">
                                    <option :value="option.id" :key="option.id">
                                        {{ option.name }}
                                    </option>
                                </template>
                            </select>
                        </div>
                    </div>

                    <div class="form-group col-md-6">
                        <label for="select_address" class="col-lg-12 label-primary">{{ lang.cityNeighbor }}</label>
                        <select id="select_address"
                                class="selectpicker form-control select-primary col-lg-12"
                                multiple
                                v-on:change="removeCurrentPage"
                                :title="lang.allNeighbors"
                                v-model="vueGetSelectedOption.address">

                            <option value="default" selected="selected">{{ lang.allNeighbors }}</option>

                            <template v-for="option of vueCreateAddress">
                                <option :value="option.id" :key="option.id">
                                    {{ option.name }}
                                </option>
                            </template>

                        </select>
                    </div>
                </div>

                <div class="input-wrapper">
                    <template>
                        <label class="col-lg-12 label-primary">{{ lang.areaMeters }}</label>
                        <div class="input-panel">
                            <input id="areaMinValue" type="number"
                                   class="input-primary"
                                   v-on:change="removeCurrentPage"
                                   v-model="inputNumbers.area_min"
                                   :placeholder="lang.min"/>

                            <input id="areaMaxValue" type="number"
                                   class="input-primary"
                                   v-on:change="removeCurrentPage"
                                   v-model="inputNumbers.area_max"
                                   :placeholder="lang.max"/>
                        </div>
                    </template>
                </div>

                <div class="input-wrapper input-wrapper-price">
                    <!--<template v-if="authentication === false">
                        &lt;!&ndash; Auth Guard Layer &ndash;&gt;
                        <div class="layer-guard"></div>
                        <label class="col-lg-12 label-primary blur-effect-soft">{{ lang.budgetEuro }}</label>
                        <div class="input-panel">
                            <div class="input-group">
                                <span class="input-group-text blur-effect-soft">€</span>
                                <span class="input-primary blur-effect-soft">0</span>
                            </div>
                            <div class="input-group">
                                <span class="input-group-text blur-effect-soft">€</span>
                                <span class="input-primary blur-effect-soft">0</span>
                            </div>
                        </div>
                    </template>-->

                    <template>
                        <label class="col-lg-12 label-primary">{{ lang.budgetEuro }}</label>
                        <div class="input-panel">
                            <div class="input-group">
                                <span class="input-group-text">€</span>
                                <input id="areaMinPrice"
                                       type="number"
                                       value="0"
                                       v-on:change="removeCurrentPage"
                                       v-model="priceRange.value[0]"
                                       class="input-primary"
                                       :placeholder="lang.from"/>
                            </div>
                            <div class="input-group">
                                <span class="input-group-text">€</span>
                                <input id="areaMaxPrice"
                                       type="number"
                                       value="0"
                                       v-on:change="removeCurrentPage"
                                       v-model="priceRange.value[1]"
                                       class="input-primary"
                                       :placeholder="lang.to"/>
                            </div>
                        </div>
                    </template>
                    <!-- --- -------- -->
                </div>

                <div class="input-wrapper">
                    <!--<template v-if="authentication === false">
                        &lt;!&ndash; Auth Guard Layer &ndash;&gt;
                        <div class="auth-guard"></div>

                        <div class="price-wrapper">
                            <span class="price-item">
                                <span class="blur-effect-soft">€</span>
                                <span class="blur-effect-soft">000</span>
                            </span>
                            <span class="price-item blur-effect-soft">-</span>
                            <span class="price-item">
                                    <span class="blur-effect-soft">€</span>
                                    <span class="blur-effect-soft">000 000</span>
                                </span>
                        </div>

                        <vue-slider
                                id="priceRangeLogout"
                                class="blur-effect-soft"
                                v-model="priceRange.value"
                                :interval="100"
                                :max="priceMaxValue"
                        ></vue-slider>

                    </template>-->
                    <template>
                        <div class="price-wrapper">
                            <span class="price-item">
                                <span>€</span>
                                <span v-text="priceRange.value[0]"></span>
                            </span>
                            <span class="price-item">-</span>
                            <span class="price-item">
                                <span>€</span>
                                <span v-text="priceRange.value[1]"></span>
                            </span>
                        </div>

                        <vue-slider
                                id="priceRange"
                                v-model="priceRange.value"
                                v-on:change="removeCurrentPage"
                                :interval="100"
                                :max="priceMaxValue"
                        ></vue-slider>

                    </template>
                </div>


                <!-- 'Employees' Input / 'Workplace' Input are hided. If you need to show them, remove v-if directive -->
                <!-- ------------------------------ -->
                <template v-if="!show">
                    <div class="input-wrapper mt-3">
                        <div class="input-panel">
                            <div class="select2-panel">
                                <div class="form-group">
                                    <label for="select_employees" class="col-lg-12 label-primary">{{ lang.employeesCount
                                        }}</label>
                                    <select id="select_employees"
                                            class="selectpicker form-control select-primary col-lg-12"
                                            v-on:change="removeCurrentPage"
                                            v-model="vueGetSelectedOption.employees">

                                        <template v-for="option of vueCreateSelectOptions.employees">
                                            <option value="default" disabled selected>{{ lang.employeesCount }}</option>
                                            <option :value="option">
                                                <template v-for="langItem of langForm">
                                                    <template v-if="option === langItem.key">
                                                        {{ langItem.value }}
                                                    </template>
                                                </template>
                                            </option>
                                        </template>
                                    </select>
                                </div>
                            </div>

                            <div class="select2-panel">
                                <div class="form-group">
                                    <label for="select_workspace" class="col-lg-12 label-primary">{{ lang.workSpace
                                        }}</label>
                                    <select id="select_workspace"
                                            class="selectpicker form-control select-primary col-lg-12"
                                            :title="lang.workSpace"
                                            v-on:change="removeCurrentPage"
                                            v-model="vueCreateSelectOptions.workspace">

                                        <template v-for="option of vueCreateSelectOptions.workspace">
                                            <option :value="option">
                                                <template v-for="langItem of langForm">
                                                    <template v-if="option === langItem.key">
                                                        {{ langItem.value }}
                                                    </template>
                                                </template>
                                            </option>
                                        </template>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="input-wrapper">
                        <div class="input-panel">
                            <div class="select2-panel">
                                <div class="form-group">
                                    <label for="select_contract" class="col-lg-12 label-primary">{{
                                        lang.contractDuration }}</label>
                                    <select id="select_contract"
                                            class="selectpicker form-control select-primary col-lg-12"
                                            title="Placeholder"
                                            v-on:change="removeCurrentPage"
                                            v-model="vueGetSelectedOption.contract_duration">

                                        <template v-for="option of vueCreateSelectOptions.contract_duration">
                                            <option :value="option">
                                                <template v-for="langItem of langForm">
                                                    <template v-if="option === langItem.key">
                                                        {{ langItem.value }}
                                                    </template>
                                                </template>
                                            </option>
                                        </template>
                                    </select>
                                </div>
                            </div>
                            <div class="select2-panel">
                                <div class="form-group">
                                    <label for="select_apply" class="col-lg-12 label-primary">{{ lang.applyDuration
                                        }}</label>
                                    <select id="select_apply"
                                            class="selectpicker form-control select-primary col-lg-12"
                                            :title="lang.applyDuration"
                                            v-on:change="removeCurrentPage"
                                            v-model="vueGetSelectedOption.apply">

                                        <template v-for="option of vueCreateSelectOptions.apply">
                                            <option :value="option">
                                                <template v-for="langItem of langForm">
                                                    <template v-if="option === langItem.key">
                                                        {{ langItem.value }}
                                                    </template>
                                                </template>
                                            </option>
                                        </template>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
                <!-- ------------------------------ -->

                <div class="tags-panel">
                    <div class="col-lg-12 label-primary text-uppercase">{{ lang.statusBuilding_title }}</div>
                    <div class="btn-group-toggle tags-wrapper">
                        <template v-for="checkbox of checkboxes.statuses">
                            <label class="btn tag" :class="{'active' : checkboxes.statusesChecked.indexOf(checkbox) !== -1}" :for="checkbox">
                                <input type="checkbox"
                                       name="options"
                                       :value="checkbox"
                                       :id="checkbox"
                                       autocomplete="off"
                                       v-on:change="removeCurrentPage"
                                       v-model="checkboxes.statusesChecked">
                                <template v-for="langItem of langForm">
                                    <slot v-if="checkbox === langItem.key">
                                        {{ langItem.value }}
                                    </slot>
                                </template>
                            </label>
                        </template>
                    </div>
                </div>

                <div class="checkbox-panel">
                    <div class="col-lg-12 label-primary text-uppercase">{{ lang.additionalInfo_title }}</div>

                    <template v-for="checkbox of checkboxes.additionalInfo">
                        <label class="checkbox-custom" :for="checkbox">
                                <span class="checkbox-label">
                                    <template v-for="langItem of langForm">
                                        <slot v-if="checkbox === langItem.key">
                                            {{ langItem.value }}
                                        </slot>
                                    </template>
                                </span>
                            <input type="checkbox"
                                   :id="checkbox"
                                   :value="checkbox"
                                   v-on:change="removeCurrentPage"
                                   v-model="checkboxes.additionalInfoChecked">
                            <span class="checkmark"></span>
                        </label>
                    </template>
                </div>
            </div>

            <div class="buttons-panel">
                <button id="btnSave" class="btn btn-main animated grey"
                        :aria-label="lang.save" type="button"
                        @click="saveFilter('localStorage')">
                    <span>{{ lang.save }}</span>

                </button>
                <!--<button id="btnSubmit" class="btn btn-main  btn-search float-right" type="button">-->
                <button id="btnSubmit" class="btn btn-main animated float-right"
                        :aria-label="lang.search" type="button"
                        @click="submitFilter(true)">
                    <span>{{ lang.search }}</span>

                </button>
            </div>
        </form>
    </div>
</template>

<script>
  require('../../../../../plugins-config/plugins-config.js');
  import {bus} from '../../filter-parent';
  import axios from 'axios';

  import VueSlider from 'vue-slider-component'
  import 'vue-slider-component/theme/default.css'

  const lang = $('body').data().locale;
  const enPrefix = lang === 'en' ? '/en' : '';

  export default {

    /**************** Presentation Part - Template ****************/
    /*************************************************************/
    name: "filter-component",
    props: {
      formOfferTypes: {
        type: Array
      },

      formRoomTypes: {
        type: Array
      },

      formCities: {
        type: Array
      },
      formNeighborAddress: {
        type: Array
      },
      formMinPrice: {
        type: Number
      },
      formMaxPrice: {
        type: Number
      },
      /**
       * Get inputs from /config/website.php
       */
      formBuildingStatuses: {
        type: Array
      },

      //Checkboxes
      formAdditionalCriteria: {
        type: Array
      },

      /**
       * formData prop collects all input values
       */
      formData: '',

      /**
       * holds all properties (offers)
       */
      offersData: '',

      /**
       * check User LogIn / LogOut ( returns 'true' or 'false')
       */
      authCheck: ''
    },
    data() {
      return {
        loading: false,

        counter: 0,

        offers: this.offersData,

        /**
         * Auth check - handles User Log In/ Log Out state
         */
        authentication: this.authCheck,

        /**
         * Filter Form
         */
        vueCreateAddress: [],

        /**
         * Bootstrap Select - Elements
         */
        vueCreateSelectOptions: {

          offer: this.formOfferTypes,

          room: this.formRoomTypes,

          city: this.formCities,

        },

        /**
         * Bootstrap Select - Elements
         */
        vueGetSelectedOption: {
          offer: [],

          room: [],

          city: [],

          address: [],

          employees: [],

          workspace: [],

          contract_duration: [],

          apply: [],
        },

        /**
         * Total Floorage
         */
        inputNumbers: {
          area_min: null,
          area_max: null,
        },
        total_floorage: '',

        /**
         * Price - Rent/Sale
         */
        priceRange: {
          value: [this.formMinPrice, this.formMaxPrice]
        },
        priceMaxValue: this.formMaxPrice + 1000,
        priceMinValue: this.formMinPrice,

        monthly_rent: '',

        /**
         * Building Status / Additional Info
         */
        checkboxes: {
          statuses: this.formBuildingStatuses,
          statusesChecked: [],
          additionalInfo: this.formAdditionalCriteria,
          additionalInfoChecked: [],
        },
        // ****** Filter Form  End ***//

        validCitySelect: '',

        /**
         * Form State - Default
         */
        formState: this.formData,

        /**
         * Translations
         */
        lang: jsLangs,
        langForm: [
          //** Select - Room Type
          {key: 'office', value: jsLangs.room_office},
          {key: 'apartment', value: jsLangs.room_apartment},

          //** Select - Offer Type
          {key: 'rent', value: jsLangs.offer_rent},
          {key: 'sale', value: jsLangs.offer_sale},

          //** Statuses
          {key: 'completed', value: jsLangs.statusBuilding_data_completed},
          {key: 'planned', value: jsLangs.statusBuilding_data_planned},
          {key: 'under_construction', value: jsLangs.statusBuilding_data_under_construction},

          //** Additional Information
          {key: 'furnished', value: jsLangs.additionalInfo_data_furnished},
          {key: 'unfurnished', value: jsLangs.additionalInfo_data_unfurnished},
          {key: 'parking', value: jsLangs.additionalInfo_data_parking},
          {key: 'public_transport_stops', value: jsLangs.additionalInfo_data_public_transport_stops},
          {key: 'elevator', value: jsLangs.additionalInfo_data_elevator},
          {key: 'heating', value: jsLangs.additionalInfo_data_heating},
          {key: 'cooling', value: jsLangs.additionalInfo_data_cooling},
          {key: 'ventilation', value: jsLangs.additionalInfo_data_ventilation},
          {key: 'computer_cabling', value: jsLangs.additionalInfo_data_computer_cabling},
          {key: 'internet_connection', value: jsLangs.additionalInfo_data_internet_connection},
          {key: 'ups_network', value: jsLangs.additionalInfo_data_ups_network},
          {key: 'reserved_power_supply', value: jsLangs.additionalInfo_data_reserved_power_supply},
          {key: 'metro_station', value: jsLangs.additionalInfo_data_metro_station},
        ],

        /*** Helpers ***/
        //** Hide / Show ** //
        show: true,

        loadedData: null,
      }
    },
    components: {
      VueSlider
    },

    /**************** Business Logic Part - Methods ****************/
    /*************************************************************/
    computed: {
      /**
       * HINT!
       * stateManager will collects data from Filer Form and send it to the server
       * if you want to change props names of the requests you can change it from here
       */
      stateManager: {
        get() {
          let state = {
            filter_offer_type: this.vueGetSelectedOption.offer,
            filter_property_types: this.vueGetSelectedOption.room,

            city_id: this.vueGetSelectedOption.city,
            filter_district_id: this.vueGetSelectedOption.address,

            //filter_total_floorage: (this.inputNumbers.area_min || this.inputNumbers.area_max) ? `><${(this.inputNumbers.area_min ? this.inputNumbers.area_min : '')},${(this.inputNumbers.area_max ? this.inputNumbers.area_max : '')}` : null,

            filter_total_floorage: (this.inputNumbers.area_min && this.inputNumbers.area_max) ?
              (this.inputNumbers.area_min === this.inputNumbers.area_max) ?
                `=${(this.inputNumbers.area_max)}` :
                `>< ${(this.inputNumbers.area_min)}, ${(this.inputNumbers.area_max)}`
                :
              (this.inputNumbers.area_min) ?
                `>${(this.inputNumbers.area_min)}` : (this.inputNumbers.area_max) ?
                  `<${(this.inputNumbers.area_max)}` : null,

            filter_monthly_rent: `><${this.priceRange.value[0]},${this.priceRange.value[1]}`,

            /*employees: {
                slug: '',
                text: ''
            },*/
            /*workspace: {
                slug: '',
                text: ''
            },*/

            /*contract_duration: {
                slug: '',
                text: ''
            },*/
            /*apply: {
                slug: '',
                text: ''
            },*/

            building_status: this.checkboxes.statusesChecked,
            additional_info: this.checkboxes.additionalInfoChecked,
          };

          return state;
        }
      },
    },
    methods: {
      /**
       * Set districts filter on load or on submit
       *
       * @param input
       * @param output
       * @param value Value to process
       */
      setDistrictsFilter: function (input, output, value) {
        let result;

        if (input === 'array' && output === 'string' && value && Array.isArray(value)) {
          let filterDistrict = 'i=';

          value.forEach((val, index) => {
            if(val === 'default') {
              val = '';
            }
            filterDistrict += val + (val && index < value.length - 1 ? ',' : '');
          });

          if(filterDistrict === 'i=') {
            filterDistrict = '';
          }

          value = filterDistrict;
          result = value;
        } else if (input === 'string' && output === 'array' && value) {
          const tempArr = value.split(',');
          tempArr[0] = tempArr[0].replace('i=', '');

          const index = tempArr.indexOf('default');
          if (index > -1) {
            tempArr.splice(index, 1);
          }

          result = tempArr;
        } else if (input === output && value) {
          result = value === 'i=default' ? '' : value;
        } else if (output === 'array' && !value) {
          result = []
        } else if (output === 'string' && !value) {
          result = ''
        }

        return result;
      },

      /**
       * Load default offers to offer
       *
       * @returns {Vue | any}
       */
      loadDefaultOffers: function () {
        /**
         * Assign this.formState to this.stateManager to get Default Form State
         */
        this.formState = this.stateManager;
        this.validateFormData(this.formState);

        /**
         * Emit Default State of Filter Form to Catalogue Component and Map Component
         */
        return bus.$emit('getFormDefaultState', this.formState);
      },

      /**
       * Will fetch data from the server and create Filter From Elements
       */
      createFilterFrom: function () {
        const selectOffer = $('#select_offer');
        selectOffer.val('default');
        selectOffer.selectpicker('render');

        const selectRoomType = $('#select_room_type');
        selectRoomType.val('default');
        selectRoomType.selectpicker('render');

        const routeCities = '/api/locations/cities';
        const routeAddress = '/api/locations/districts';
        const selectCity = $('#select_city');
        const selectAddress = $('#select_address');

        return axios
          .get(routeCities)
          .then((response) => {
            /**
             * Validate Response
             */
            this.validCitySelect = response.data.data;

            /**
             * Get Select Options from /config/website.php
             */
            this.vueCreateSelectOptions.city = response.data.data;

            return response;
          })
          .then((response) => {
            selectCity.selectpicker('render');
            selectCity.on('change', () => {
              const cityId = selectCity.val();

              if (cityId !== 'default' && cityId > 0) {

                axios
                  .get(routeAddress, {params: {city_id: cityId, limit: 9999}})
                  .then(response => {

                    /**
                     * Create Address
                     */
                    this.vueCreateAddress.length = 0;
                    this.vueCreateAddress = response.data.data;

                    return response;
                  })
                  .then(() => {
                    selectAddress.removeAttr('disabled');
                    selectAddress.selectpicker('render');
                    selectAddress.selectpicker('refresh');
                  })
                  .catch((err) => console.log(err));

              } else {
                selectAddress.val(0);
                selectAddress.attr('disabled', true);
                selectAddress.selectpicker('refresh');
              }

            }).trigger('change');

            return response;

          })
          .catch((err) => console.log(err));
      },

      /**
       * On submit
       *
       * @param save Whether to save the current filter or not
       */
      submitFilter: function (save) {
        const sessionState = JSON.parse(sessionStorage.getItem('State'));
        this.formState = this.stateManager;

        //Trash but works
        this.formState['filter_district_id'] = this.vueGetSelectedOption.address;

        if (this.$route.path === enPrefix + '/properties') {
          this.formState['limit'] = 9999;
          if(this.formState['page']) {
            delete this.formState['page'];
          }
        } else {
          if(sessionState) {
            if(sessionState['page']) {
              this.formState['page'] = sessionState['page'];
            }
          }
          this.formState['limit'] = null;
        }

        this.validateFormData(this.formState);
        this.homepageFilterForm();


        if (this.formState.filter_district_id && this.formState.filter_district_id.length > 0) {
          this.formState.filter_district_id = this.setDistrictsFilter('array', 'string', this.formState.filter_district_id)
        } else if (this.vueGetSelectedOption.address && this.vueGetSelectedOption.address.length > 0) {
          this.formState.filter_district_id = this.setDistrictsFilter('array', 'string', this.vueGetSelectedOption.address)
        } else if (sessionState && sessionState.filter_district_id && sessionState.filter_district_id.length > 0) {
          this.formState.filter_district_id = sessionState.filter_district_id;
        }

        if (this.formState.filter_district_id && this.vueGetSelectedOption.city) {
          this.formState.city_id = this.vueGetSelectedOption.city;
        } else if (sessionState && sessionState.city_id) {
          if (this.formState.city_id === sessionState.city_id) {
            this.formState.city_id = sessionState.city_id;
          }
        }

        if (save) this.saveFilter('sessionStorage');

        /**
         * Emit response after send formState as params
         */
        axios
          .get(enPrefix + '/api/properties', {params: {...this.formState}})
          .then(response => {
            this.loadedData = response;

            bus.$emit('searchResults', response);

            bus.$emit('searchFilters', this.formState);
          })
          .catch(err => console.log(err));
      },

      /**
       * Save filter logic
       *
       * @param storage
       */
      saveFilter: function (storage) {
        localStorage.removeItem('State');
        sessionStorage.removeItem('State');

        if (storage === 'sessionStorage') {
          sessionStorage.setItem('State', JSON.stringify(this.formState));
        } else if (storage === 'localStorage') {
          localStorage.setItem('State', JSON.stringify(this.formState));
          toastr.info(this.lang.toastrMsg_searchDataSaved_text, this.lang.toastrMsg_searchDataSaved_title);
        }
      },

      /**
       * Get form's state data
       */
      getFormState: function () {
        const self = this;
        /**
         * Selectors
         */
        const selectOffer = $("#select_offer");
        const selectRoomType = $("#select_room_type");
        const selectCity = $("#select_city");
        const selectAddress = $("#select_address");

        /**
         * Get Form Data from Session Storage
         */
        let getFormData = sessionStorage.getItem('State');

        if (!getFormData && localStorage.getItem('State')) {
          getFormData = localStorage.getItem('State')
        }

        /**
         * Autofill Form Elements
         */
        if (getFormData !== null) {
          const dataFormParser = JSON.parse(getFormData);

          if (dataFormParser.filter_offer_type) {
            /**
             * Use 'Document Ready' wrapper to ensure Select Offer data exists in DOM
             */
            $(function () {
              self.offerTypesSelected = dataFormParser.filter_offer_type;

              selectOffer.selectpicker('val', self.offerTypesSelected);
              self.vueGetSelectedOption.offer = self.offerTypesSelected;
              selectOffer.selectpicker('render');
              selectOffer.selectpicker('refresh');
            });
          }

          if (dataFormParser.filter_property_types) {
            /**
             * Use 'Event Loop' to ensure Select Property Type data exists in DOM
             */
            $(function () {
              self.roomTypesSelected = dataFormParser.filter_property_types;

              selectRoomType.selectpicker('val', self.roomTypesSelected);
              self.vueGetSelectedOption.room = self.roomTypesSelected;

              selectRoomType.selectpicker('render');
              selectRoomType.selectpicker('refresh');
            });
          }

          /**
           *  Validate Request - Fill Selects ASAP Request is ready
           */
          this.createFilterFrom().then(validResponseCities => {
            if (validResponseCities) {
              if (dataFormParser.city_id) {
                /**
                 * Get City
                 */
                self.vueGetSelectedOption.city = dataFormParser.city_id;
                self.formState.city_id = self.vueGetSelectedOption.city;

                selectCity.selectpicker('val', this.vueGetSelectedOption.city);
                selectCity.selectpicker('render');
                selectCity.selectpicker('refresh');

                /**
                 * Send 'district_id' onchange Event
                 */
                selectCity.change();

                /**
                 * Get District(s)
                 */
                self.vueGetSelectedOption.address = self.setDistrictsFilter('string', 'array', dataFormParser.filter_district_id);
                self.formState.filter_district_id = self.setDistrictsFilter('string', 'string', dataFormParser.filter_district_id);
                selectAddress.removeAttr('disabled');
                selectAddress.selectpicker('render');
                selectAddress.selectpicker('refresh');
              }
              selectCity.selectpicker('render');
              selectCity.selectpicker('refresh');
            }

            if (dataFormParser.filter_total_floorage) {
              this.total_floorage = dataFormParser.filter_total_floorage;

              if(this.total_floorage.charAt(0) === '>' && this.total_floorage.charAt(1) === '<' || this.total_floorage.charAt(0) === '=') {
                this.inputNumbers.area_min = this.total_floorage.match(/\d+/g).map(Number)[0];
                this.inputNumbers.area_max = this.total_floorage.match(/\d+/g).map(Number)[1];
              } else if(this.total_floorage.charAt(0) === '<') {
                this.inputNumbers.area_max = this.total_floorage.match(/\d+/g).map(Number)[0];
              } else {
                this.inputNumbers.area_min = this.total_floorage.match(/\d+/g).map(Number)[0];
              }
            }

            if (dataFormParser.filter_monthly_rent) {
              $(function () {
                self.monthly_rent = dataFormParser.filter_monthly_rent;
                self.priceRange.value = [self.monthly_rent.match(/\d+/g).map(Number)[0], self.monthly_rent.match(/\d+/g).map(Number)[1]];
              });
            }

            if (dataFormParser.building_status) {
              this.checkboxes.statusesChecked = dataFormParser.building_status;
            }
            if (dataFormParser.additional_info) {
              this.checkboxes.additionalInfoChecked = dataFormParser.additional_info;
            }

            /*bus.$emit('componentLoaded');*/
          });

        } else {
          this.clearFilterForm();
        }
      },

      /**
       * Clears All values of Filter Form (text elements included)
       */
      clearFilterForm: function () {
        this.vueGetSelectedOption.offer = [];
        $('[data-id="select_offer"]').find('.filter-option-inner-inner').text(this.lang.allOffers);

        this.vueGetSelectedOption.room = [];
        $('[data-id="select_room_type"]').find('.filter-option-inner-inner').text(this.lang.allRoomTypes);

        this.vueGetSelectedOption.city = [];
        $('[data-id="select_city"]').find('.filter-option-inner-inner').text(this.lang.allCities);

        this.vueGetSelectedOption.address = [];
        $('[data-id="select_address"]').find('.filter-option-inner-inner').text(this.lang.allNeighbors);
        const selectAddress= $("#select_address");
        selectAddress.val(0);
        selectAddress.attr('disabled', true);
        selectAddress.selectpicker('refresh');

        this.vueGetSelectedOption.workspace = [];
        this.vueGetSelectedOption.contract_duration = [];
        this.vueGetSelectedOption.apply = [];

        this.inputNumbers.area_min = null;
        this.inputNumbers.area_max = null;

        this.priceRange.value[0] = this.formMinPrice;
        this.priceRange.value[1] = this.formMaxPrice;

        this.checkboxes.statusesChecked = [];
        const tag = $(".tags-wrapper .tag");
        tag.each(function () {
          $(this).removeClass("active");
        });

        this.checkboxes.additionalInfoChecked = [];

        sessionStorage.removeItem('State');
        sessionStorage.removeItem('HomepageState');

        localStorage.removeItem('State');
        localStorage.removeItem('HomepageState');
      },

      /**
       * Helpers - Utility methods
       */
      clearFormMsg: function () {
        toastr.info(this.lang.toastrMsg_searchDataDeleted_text, this.lang.toastrMsg_searchDataDeleted_title);
        toastr.clear();
      },

      /**
       * Auth check Method - handles User Log In / Log Out
       */
      priceRangeGuard: function () {
        const button = $("#priceRangeLogout").find("button");

        if (this.authentication === false) {
          button.prop('disabled', true);
          button.addClass("stop");
        } else {
          button.removeAttr('disabled');
          button.removeClass("stop");
        }

        /** Warning Message **/
        const layerGuard = $('.layer-guard');
        /** Use 'one' callback to prevent multiple clicks  */
        if (this.authentication === false) {
          layerGuard.one('click', () => {
            toastr.info(this.lang.toastrMsg_unAuthenticated_text, this.lang.toastrMsg_unAuthenticated_title);
          });
        }
      },

      /**
       * validateFormData method is helper to exclude properties from FormState Requests
       * which are equal to 'null', 'undefined' 'false' etc..
       *
       * @param form Form to validate
       */
      validateFormData: function (form) {

        Object.keys(form).forEach(key => {
          if (key === 'filter_district_id' && !('city_id' in form)) {
            delete form['filter_district_id']
          }

          if (
            form[key] === undefined ||
            form[key] === false ||
            form[key] === null ||
            form[key] === 'default' ||
            form[key] === '><null,null' ||
            form[key] === '=null' ||
            form[key] === '<null' ||
            form[key] === '>null' ||
            form[key].length === 0
          ) {
            delete form[key];
          }
        });
      },

      /**
       * Determine if homepage Filter has been submitted
       */
      homepageFilterForm: function () {
        const isFormHomepageSubmitted = sessionStorage.getItem('HomepageForm');
        if (isFormHomepageSubmitted !== null) {
          //this.clearFilterForm();
          //toastr.info(this.lang.filterAgain, this.lang.warning);
          sessionStorage.removeItem('HomepageForm');
        }
      },

      /**
       * Load data and emit response
       *
       * @param state Pass a custom formState (optional)
       */
      loadData(state) {
        let stateData = null;
        if (!state) {
          stateData = this.formState
        } else {
          stateData = state;
        }
        axios
          .get(enPrefix + '/api/properties', {params: stateData})
          .then((response) => {
            this.loadedData = response;

            bus.$emit('searchResults', response);
          })
          .catch((err) => console.log(err));
      },

      /**
       * On tabs change
       */
      updateOnRoute: function () {

        //When there is no session storage load the data
        /*if (!sessionStorage.getItem('State')) {

          const customState = {...this.formState};
          if (this.$route.path === enPrefix + '/properties') {
            customState['limit'] = 9999;
          } else {
            if (this.$route.query['filter_id']) {
              customState['filter_id'] = this.$route.query['filter_id'];
            }
            customState['limit'] = null;
          }
          delete customState['page'];

          this.loadData(customState);
          bus.$emit('searchFilters', this.formState);
        }*/

        bus.$on('componentLoaded', () => {
          const getFormData = sessionStorage.getItem('State');
          if (!this.loadedData) {
            if(!JSON.parse(getFormData)) {
              this.submitFilter(false);
              return false;
            }
          }
          this.loadedData = JSON.parse(getFormData);
          const customState = {...this.loadedData};
          if (this.$route.path === enPrefix + '/properties') {
            customState['limit'] = 9999;
            delete customState['page'];
          } else {
            if (this.$route.query['filter_id']) {
              customState['filter_id'] = this.$route.query['filter_id'];
            }
            if(customState['limit']) {
              customState['limit'] = null;
            }
          }

          this.loadData(customState);
        })
      },

      /**
       * On filter change remove page ID
       */
      removeCurrentPage() {
        const sessionState = JSON.parse(sessionStorage.getItem('State'));

        if(sessionState) {
          if(sessionState['page']) {
            delete sessionState['page'];
          }
          sessionStorage.setItem('State', JSON.stringify(sessionState));
        }
      },
      /**
       * Debugging
       */
      log: function (value) {
        console.log(value);
      }
    },
    mounted() {
      this.loadDefaultOffers();
      this.createFilterFrom();
      this.getFormState();
      this.priceRangeGuard();
      this.updateOnRoute();
      /*setTimeout(() => {
        this.updateOnRoute();
      });*/
    },
  }
</script>
